'use client';

import type { ReactNode, ReactElement } from 'react';
import { chain, projectId, wagmiAdapter } from '@/lib/constants/config';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { WagmiProvider } from 'wagmi';
import { createAppKit } from '@reown/appkit/react';
import { bsc, mainnet, tron } from 'viem/chains';

const queryClient = new QueryClient();

const metadata = {
  name: 'Solarious',
  description:
    'Solarious is a Proof of Energy blockchain where verified solar production secures the network and distributes token rewards.',
  url: 'https://presale-testnet.solarious.io',
  icons: [
    'https://raw.githubusercontent.com/solarious-explorer/assets/refs/heads/main/icon-light.svg',
  ],
};

createAppKit({
  projectId,
  metadata,
  features: { smartSessions: false, swaps: false, onramp: false, history: false },
  adapters: [wagmiAdapter],
  networks: [mainnet, bsc, tron, chain],
  defaultNetwork: chain,
  defaultAccountTypes: { eip155: 'eoa' },
});

export default function BlockchainProvider({
  children,
}: {
  readonly children: ReactNode;
}): ReactElement {
  return (
    <WagmiProvider config={wagmiAdapter.wagmiConfig}>
      <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>
    </WagmiProvider>
  );
}
